module.exports = __webpack_public_path__ + "static/media/TeamGreen.00b155e3.png";